import { defineStore } from 'pinia'

export const useNoticeStore = defineStore('notice', {
  state: () => ({
    unReadCount: 0
  }),
  getters: {
    getUnReadCount: state => state.unReadCount
  },
  actions: {
    setUnReadCount(count: number) {
      this.unReadCount = count
    }
  }
})
